import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Create from './Create';
import History from './History';
import List from './List';
import NotFound from '../../../copms/NotFound/NotFound';
import Detailed from './Detailed';
import transferConfirmation from "../img/transfer-confirmation.svg"
import { translate } from 'react-i18next';

class OpenBanking extends Component {
    state = {
        link: ''
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.setState({ link: window.location.pathname.split('/')[5] ? window.location.pathname.split('/')[5] : window.location.pathname.split('/')[4] })
        }
    }

    componentDidMount = () => {
        this.setState({ link: window.location.pathname.split('/')[5] ? window.location.pathname.split('/')[5] : window.location.pathname.split('/')[4] })
    }

    render() {
        let { link } = this.state;
        let { t, updateAppState, updateDashboardState, alertState, logout } = this.props;
        return (
            <>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{this.props.t('Open Banking')}</h2>
                    </div>
                </div>
                <div className="dashboard-account-body">
                    <div className="dashboard-account-body-data-section" style={{ marginTop: '1px' }}>
                        <Switch>
                            <Redirect exact from="/dashboard/open-banking/" to="/dashboard/open-banking/consent/create" />
                            <Redirect exact from="/dashboard/open-banking/list/consents" to="/dashboard/open-banking/list/consents/incoming" />
                            <Route path="/dashboard/open-banking/consent/create" render={(routeProps) => <Create logout={() => logout()} {...routeProps} updateAppState={updateAppState} updateDashboardState={updateDashboardState} alertState={alertState} />} />
                            <Route path={["/dashboard/open-banking/list/consents/given/:id",
                                "/dashboard/open-banking/list/consents/incoming/:id",
                                "/dashboard/open-banking/list/consents/sent/:id",
                                "/dashboard/open-banking/list/accounts/account/:id",
                                "/dashboard/open-banking/list/history/item/:id"]}
                                render={(routeProps) => <Detailed logout={() => logout()} {...routeProps} updateAppState={updateAppState} updateDashboardState={updateDashboardState} alertState={alertState} />} />
                            <Route path={["/dashboard/open-banking/list/consents/given",
                                "/dashboard/open-banking/list/consents/incoming",
                                "/dashboard/open-banking/list/consents/sent",
                                "/dashboard/open-banking/list/accounts"
                            ]} render={(routeProps) => <List logout={() => logout()} {...routeProps} updateAppState={updateAppState} updateDashboardState={updateDashboardState} alertState={alertState} />} />
                            <Route path="/dashboard/open-banking/list/history" render={(routeProps) => <History logout={() => logout()} {...routeProps} updateAppState={updateAppState} updateDashboardState={updateDashboardState} alertState={alertState} />} />
                            <Route render={() => <NotFound />} />
                        </Switch>
                    </div>
                    <div className="dashboard-payment-container-confirmation-section">
                        <div className="dashboard-payment-container-confirmation-section-header">
                            <h3 className="dashboard-payment-container-confirmation-section-header-title">{t('Information')}</h3>
                        </div>
                        <div className="dashboard-payment-container-confirmation-section-content">
                            <img src={transferConfirmation} className="dashboard-payment-container-confirmation-section-content-image" alt="open-banking" />
                            <div className="dashboard-payment-container-confirmation-section-content-description">
                                <p>{link === 'accounts' ? t('Linked Accounts') : link === 'given' ? t('Granted Consents') : link === 'incoming' ? t('Incoming Consent Requests') : link === 'sent' ? t('Sent Consent Requests') : link === 'item' ? t('Create New Consent') : link === 'history' ? t('History Consents') : ""}</p>
                                <p>{t('What is Open Banking?')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        )
    }
}
export default translate("translation")(OpenBanking);
